import type { JSX } from 'react';

export const MAIN_CONTENT_ID = 'main-content';

/**
 * Visually hidden until focused. Kept as the first focusable element in the
 * document so keyboard and screen-reader users can bypass the navigation.
 */
export function SkipLink(): JSX.Element {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:inline-flex focus:min-h-11 focus:items-center focus:rounded-md focus:bg-accent-solid focus:px-5 focus:py-2.5 focus:text-sm focus:font-medium focus:text-accent-contrast"
    >
      Skip to main content
    </a>
  );
}
